module.exports = __webpack_public_path__ + "static/media/ml.1dd7a9cc.svg";